<div id="main" data-cy="forms-dialog-container">
  <b data-cy="forms-procedure-name">{{data.procedure.ProcedureName}}</b>
  <br />
  <b data-cy="forms-procedure-code">{{data.procedure.Code}}</b>
  <br />
  <div id="form" *ngIf="isReady" data-cy="forms-content-container">
    <app-forms-form [dataForm]="data" data-cy="forms-form-component"></app-forms-form>
  </div>
</div>
